import { withStyles } from "@material-ui/core";
import React from "react";
import StyledToolTip from "../../../../../../common/StyledToolTip";
import { getPickupStatusTypeIcon } from "../../../utils/pickupStatusTypeIcon";

const styles = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  pickupNumber: {
    paddingRight: 4,
  },
});

const PickupNumberRefreshed = ({
  theme,
  classes,
  getTitle,
  pickupStatus,
  value,
}) => {
  const getPickupIcon = () => {
    const params = {
      theme,
      status: pickupStatus,
    };
    const markerInfo = getPickupStatusTypeIcon(params);
    return (
      <StyledToolTip title={getTitle(markerInfo.type)}>
        <div>{markerInfo.marker}</div>
      </StyledToolTip>
    );
  };

  return (
    <div className={classes.container}>
      <span className={classes.pickupNumber}>{value}</span>
      {getPickupIcon()}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PickupNumberRefreshed);
